import React from 'react';
import Paste from '../components/Paste';
import useAppID from '../hooks/useAppId';
import usePong from '../hooks/usePong';
import QrCode from 'qrcode.react'
import { Link } from '@reach/router';

function Info(props: any) {
  const { data } = usePong();
  const ID = useAppID();
  

  return (
    <div className="info">
      {data?.pong}

      <h5>Your ID is: {ID}</h5>

      <QrCode value={ID!} />

          <Paste />
          
          <Link to="/share">Share</Link>
    </div>
  );
}

export default Info;
